import { render, staticRenderFns } from "./Pendencies.vue?vue&type=template&id=bbb0be34&scoped=true&"
import script from "./Pendencies.vue?vue&type=script&lang=js&"
export * from "./Pendencies.vue?vue&type=script&lang=js&"
import style0 from "./Pendencies.vue?vue&type=style&index=0&id=bbb0be34&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb0be34",
  null
  
)

export default component.exports